import Enumerable from "linq";
import {
  IExternalSystemGetObjectValuesResultBean,
  IExternalSystemValidationRequestResultBean,
  IExternalRequestSearchResultBean,
  IExternalSystemValidationResultBean,
} from "../../document/ver2/beans";
import {
  RequestedObject,
  ExternalSystemObjectValuesResponce,
  ExternalSystemValidationResult,
  ExternalValidationResultAlert,
} from "../../../domain/document";
import {
  ExternalSystemGetObjectValuesResult,
  ExternalSystemValidationRequestResult,
} from "../../../domain/externalSystem";


export class ExternalSystemTranslator {
  public toExternalSystemGetObjectValuesResult(source: IExternalSystemGetObjectValuesResultBean): ExternalSystemGetObjectValuesResult {
    if (!source) { return null; }
    const result = source.result ? JSON.parse(source.result.toString()) : null;
    return new ExternalSystemGetObjectValuesResult(
      source.isOk,
      source.message,
      this.toExternalSystemObjectValuesResponce(result),
    );
  }

  public toExternalSystemObjectValuesResponce(source: IExternalRequestSearchResultBean): ExternalSystemObjectValuesResponce {
    if (!source) { return null; }
    return new ExternalSystemObjectValuesResponce(
      source.isOk,
      source.message,
      Enumerable.from(source.objects).select(o => new RequestedObject(o.id, o.key, o.value)).toArray(),
    );
  }

  public toExternalSystemValidationRequestResult(source: IExternalSystemValidationRequestResultBean): ExternalSystemValidationRequestResult {
    if (!source) { return null; }
    const result = source.result ? JSON.parse(source.result.toString()) : null;
    return new ExternalSystemValidationRequestResult(
      source.isOk,
      source.message,
      this.toExternalSystemValidationResult(result),
    );
  }

  public toExternalSystemValidationResult(source: IExternalSystemValidationResultBean): ExternalSystemValidationResult {
    if (!source) { return null; }
    return new ExternalSystemValidationResult(
      source.isOk,
      source.message,
      Enumerable.from(source.alerts).select(o => new ExternalValidationResultAlert(o.isError, o.kind, o.description, o.id, o.name)).toArray(),
      Enumerable.from(source.objects).select(o => new RequestedObject(o.id, o.key, o.value)).toArray(),
    );
  }
}
